import Button from "components/button";
import { PlusOutlined } from '@ant-design/icons';
import { useCRUDAccess } from "utils/useCRUDAccess";

const TableAddButton = ({route, moduleId, ...rest}) => {
	
	const checkCRUDAccess = useCRUDAccess();

  	return ( <>
		{ checkCRUDAccess(moduleId, 'add') && 
			<Button extra={`btn-small ${rest}`}>
				<a href={route}>
					<PlusOutlined />{' '}Add
				</a>
			</Button>
		}
		</>
  	);
}

export default TableAddButton;
